import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

if (environment.production) {
  enableProdMode();
  const methods: (keyof Console)[] = ['log', 'debug', 'warn', 'info', 'error'];
  for (const method of methods) {
    (console[method] as (...args: any[]) => void) = (...args: any[]) => {};
  }
}

function bootstrap() {
  bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err)
  );
}

if (document.readyState === 'complete') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', bootstrap);
}
